<script setup>
/**
 * Shared photo gallery grid component.
 * Used by Rapports/Gallery, Projets/Gallery, and Bons/Gallery pages.
 */
defineProps({
  photos:                  { type: Array, default: () => [] },
  emptyMessage:            { type: String, default: 'Aucune photo disponible.' },
  showSource:              { type: Boolean, default: false },
})
</script>

<template>
  <div v-if="photos.length" class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-5">
    <article
      v-for="photo in photos"
      :key="photo.id"
      class="group block bg-surface-container rounded-xl border border-outline-variant/10 overflow-hidden shadow hover:border-primary/30 transition-colors"
    >
      <a :href="photo.url" target="_blank" rel="noopener" class="block aspect-square bg-surface-container-high overflow-hidden">
        <img
          :src="photo.thumbnail_url || photo.url"
          :alt="photo.filename || 'Photo'"
          class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
      </a>
      <div class="p-3 space-y-1.5">
        <p v-if="photo.description" class="text-xs text-on-surface-variant leading-snug">
          {{ photo.description }}
        </p>
        <p v-else class="text-xs text-outline italic">Aucun descriptif</p>
        <a
          v-if="showSource && photo.source"
          :href="photo.source.url"
          class="inline-flex items-center gap-1 text-[11px] text-primary hover:brightness-125"
        >
          <span class="material-symbols-outlined text-xs">{{ photo.source_type === 'rapport' ? 'description' : 'receipt_long' }}</span>
          {{ photo.source.label }}
        </a>
      </div>
    </article>
  </div>

  <div v-else class="bg-surface-container rounded-xl border border-outline-variant/10 p-8 text-center">
    <p class="text-sm text-outline italic">{{ emptyMessage }}</p>
  </div>
</template>
